import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { FilterKeys } from '../../../../../shared/projectsV2';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardCheckboxes from '../../../generic/Filter/FilterCardCheckboxes';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { ProjectsFilter } from '../../../../../shared/projectsV2';
import type { SelectOption } from '../../../../types';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'public', label: 'Public' },
  { value: 'private', label: 'Private' },
];

// map the optional "isPublic" boolean to an array of selected options
const determineSelectedOptions = (filter: ProjectsFilter): SelectOption[] => {
  switch (filter.isPublic) {
    case true:
      return [{ value: 'public', label: 'Public' }];
    case false:
      return [{ value: 'private', label: 'Private' }];
    default:
      return [];
  }
};

const ProjectVisibility: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    if (newSelected.length === 0) {
      setFilter({ ...filter, [FilterKeys.IsPublic]: undefined });
    } else {
      const selectedValue = newSelected[0]!.value; // Only one can be selected at a time
      if (selectedValue === 'public') {
        setFilter({ ...filter, [FilterKeys.IsPublic]: true });
      } else {
        setFilter({ ...filter, [FilterKeys.IsPublic]: false });
      }
    }
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Visibility"
        options={FILTER_OPTIONS}
        values={determineSelectedOptions(filter)}
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default ProjectVisibility;
